import React from "react";
import "./styles/onboarding.css";
import OBHeader from "./_components/OBHeader";
import OBTabBar from "./_components/OBTabBar";
import OBHavingTroubleCard from "./_components/OBHavingTroubleCard";

function OnBoardingMain() {
  return (
    <div className="ob-page-main-wrapper">
      <OBHeader />
      <div className="ob-page-main-body">
        {/* main heading */}
        <h1 className="ob-page-main-heading">
          Hi, Welcome setup your profile
        </h1>
        {/* tab and content   */}
        <div className="d-flex flex-1xl-nowrap flex-column flex-wrap flex-xl-row align-items-start gap-2 mt-3">
          <OBTabBar />
          {/* <OBHavingTroubleCard /> */}
        </div>
      </div>
    </div>
  );
}

export default OnBoardingMain;
